import React from 'react';
import type { TmsTaskWaypointType, TmsTaskDetailType } from '../../graphql/queries/getTmsTaskDetail';
import { TmsRouteTypeEnum, TmsBusinessTypeEnum } from '../../../../../enums/TmsEnum';
import UnloadingInfoSection from './components/UnloadingInfoSection';
import InboundInfoSection from './components/InboundInfoSection';

interface UnloadingDetailProps {
    waypoint: TmsTaskWaypointType;
    stepDetailAllowEdit: boolean;
    onOpenLoadingDetailDrawer?: (waypointId: number) => void;
    onOpenUnloadingDetailDrawer?: (waypointId: number) => void;
    task?: TmsTaskDetailType;
}

/**
 * 卸车步骤分发：
 * - 干线 + 自有路线 → 卸车 UnloadingInfoSection（读 tms_loading，UI 同装车）
 * - 其余            → 入库 InboundInfoSection（读 tms_unloading）
 * routeType/businessType 为 Int，运行时即 number，无需 Number()。
 */
const UnloadingDetail: React.FC<UnloadingDetailProps> = ({
    waypoint,
    stepDetailAllowEdit,
    onOpenUnloadingDetailDrawer,
    task,
}) => {
    const isLinehaulOwn =
        task?.routeType === TmsRouteTypeEnum.Linehaul && task?.businessType === TmsBusinessTypeEnum.OwnRoute;
    const Section = isLinehaulOwn ? UnloadingInfoSection : InboundInfoSection;
    return (
        <Section
            waypoint={waypoint}
            stepDetailAllowEdit={stepDetailAllowEdit}
            onOpenUnloadingDetailDrawer={onOpenUnloadingDetailDrawer}
            task={task}
        />
    );
};

export default UnloadingDetail;
